var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Notifier } from "@//common/utils/notifier";
import { Feature, CompaniesClient, GetMaintenanceLogViewPaginatedQuery, LookupsClient, MaintenanceLogsClient, PaginatedEnumerableOfMaintenanceLogQuery, SitesClient, SortDescription, SortDirection, SystemComponentsClient, SystemsClient, UsersClient } from "@/app/api/battery-portal-api";
import { MaintenanceLogQueryModel } from "@/app/models/queries/maintenance-log-query.model";
import RouteNames from "@/app/router/routes";
import { CacheHelper } from "@/app/utils/cache-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import moment from 'moment';
const systemsClient = new SystemsClient(window.apiUrl);
const componentsClient = new SystemComponentsClient(window.apiUrl);
const maintenanceClient = new MaintenanceLogsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const userClient = new UsersClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let MaintenanceHistoryVue = class MaintenanceHistoryVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.snoozeSearch = false;
        this.systemsLoaded = false;
        this.lookupsLoaded = false;
        this.componentsLoaded = false;
        this.searchAttempted = false;
        this.previousSystemId = null;
        this.datePickerConfig = {
            dateFormat: "d M Y",
            wrap: true,
            enableTime: false,
            allowInput: false
        };
        // models
        this.query = new GetMaintenanceLogViewPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            keywords: "",
            includeDeleted: false,
            companyId: null,
            siteId: null,
            systemId: null,
            authorId: null,
            componentId: null,
            logTypeId: null,
            startTime: null,
            endTime: null
        });
        this.data = new PaginatedEnumerableOfMaintenanceLogQuery();
        this.columns = [
            { visible: true, fieldName: "date", title: "Date" },
            { visible: true, fieldName: "note", title: "Note" },
            { visible: true, fieldName: "type", title: "Type" },
            { visible: true, fieldName: "location", title: "Location" },
            { visible: true, fieldName: "system", title: "System" },
            { visible: true, fieldName: "site", title: "Site" },
            { visible: true, fieldName: "company", title: "Company" },
            { visible: true, fieldName: "author", title: "Author" },
        ];
        this.systems = [];
        this.systemComponents = new Array();
        this.companies = [];
        this.sites = [];
        this.users = [];
        this.logTypes = [];
        this.dateFilterOptions = ["W", "M", "3M", "Y", "All", "..."];
        this.dateFilterOption = "";
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenEntered",
            direction: SortDirection.Descending
        }));
    }
    created() {
        this.loadDataGridState();
        this.getCachedFiltersFromLocalStorage();
    }
    ;
    mounted() {
        this.getLookups();
        this.getSystems();
    }
    ;
    // get
    getSystems() {
        systemsClient
            .getSystems(false, Feature.Comments_View)
            .then(response => {
            if (!response)
                return;
            this.systems = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        }).finally(() => {
            this.systemsLoaded = true;
        });
    }
    ;
    getLookups() {
        let promises = [
            lookupClient
                .getMaintenanceLogTypes()
                .then(response => {
                let logTypes = (response || []).map(item => {
                    return {
                        value: item.logTypeId,
                        text: item.logTypeName || ""
                    };
                });
                this.logTypes = [{ value: null, text: `All types` }].concat(logTypes);
            }),
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                if (!response)
                    return;
                this.sites = response;
            }),
            this.loadAuthors()
        ];
        Promise.all(promises).then(() => {
            this.lookupsLoaded = true;
        });
    }
    ;
    loadAuthors() {
        return lookupClient
            .getUsersForMyCompanies(this.query.companyId)
            .then(response => {
            let users = (response || []).map(item => {
                return {
                    value: item.userId,
                    text: item.displayName
                };
            });
            this.users = [{ value: null, text: `All authors` }].concat(users);
        });
    }
    getSystemComponents() {
        if (!this.query.systemId) {
            this.systemComponents = [];
            this.query.componentId = null;
            this.search();
            return;
        }
        ;
        componentsClient
            .getSystemComponents(this.query.systemId)
            .then(response => {
            if (!response) {
                this.systemComponents = [];
                return;
            }
            ;
            let systemComponents = response.map((component) => {
                return {
                    value: component.componentId,
                    text: component.displayName
                };
            });
            this.systemComponents = [{ value: null, text: `All locations` }].concat(systemComponents);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.componentsLoaded = true;
            if (this.query.systemId != this.previousSystemId) {
                this.query.componentId = null;
                this.previousSystemId = this.query.systemId;
            }
            ;
            this.search();
        });
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.readyToBindQueryStringFilters)
            return;
        if (this.snoozeSearch)
            return;
        if (this.startDateInvalid || this.endDateInvalid)
            return;
        this.working = true;
        let query = this.query;
        let startTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
        let endTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
        if (endTime != null)
            endTime = DateHelper.getEndOfDay(endTime);
        if (!DateHelper.validateDateRange(startTime, endTime)) {
            this.working = false;
            Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
            return;
        }
        CacheHelper.storeItem(RouteNames.MaintenanceComments, "MaintenanceLogQueryModel", new MaintenanceLogQueryModel(this.query, this.dateFilterOption));
        query.startTime = startTime;
        query.endTime = endTime;
        maintenanceClient
            .searchMaintenanceLogs(query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
            let params = [
                { value: this.query.companyId, parameterName: "companyId" },
                { value: this.query.systemId, parameterName: "systemId" },
                { value: this.dateFilterOption, parameterName: "period" },
            ];
            if (this.dateFilterOption == "...") {
                let startTime = this.query.startTime ? DateHelper.convertToDate(this.query.startTime.toString()).toISOString() : null;
                let endTime = this.query.endTime ? DateHelper.convertToDate(this.query.endTime.toString()).toISOString() : null;
                params.push({ value: startTime, parameterName: "startTime" });
                params.push({ value: endTime, parameterName: "endTime" });
            }
            else {
                params.push({ value: null, parameterName: "startTime" });
                params.push({ value: null, parameterName: "endTime" });
            }
            queryStringHelper.updateQueryStrings(params);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
            CacheHelper.removeItem(RouteNames.MaintenanceComments, "MaintenanceLogQueryModel");
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("comments-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    setDefaultFilters() {
        this.working = true;
        if (!queryStringHelper.hasParameter("period"))
            this.resetDateFilterOption();
        else {
            queryStringHelper.setFromQueryString("period", "W", (value) => {
                this.setDateFilterOption(value || "W");
                if (value == "...") {
                    if (queryStringHelper.hasParameter("startTime")) {
                        queryStringHelper.setFromQueryString("startTime", null, (value) => {
                            let startTime = value ? DateHelper.convertToDate(value) : null;
                            this.query.startTime = startTime;
                            return this.query.startTime;
                        });
                    }
                    if (queryStringHelper.hasParameter("endTime")) {
                        queryStringHelper.setFromQueryString("endTime", null, (value) => {
                            let endTime = value ? DateHelper.convertToDate(value) : null;
                            this.query.endTime = endTime;
                            return this.query.endTime;
                        });
                    }
                }
                return this.dateFilterOption;
            });
        }
        if (queryStringHelper.hasParameter("companyId")) {
            queryStringHelper.setFromQueryString("companyId", null, (value) => {
                this.query.companyId = value && parseInt(value) ? parseInt(value) : null;
                return this.query.companyId;
            });
        }
        if (queryStringHelper.hasParameter("systemId")) {
            queryStringHelper.setFromQueryString("systemId", null, (value) => {
                this.query.systemId = value && parseInt(value) ? parseInt(value) : null;
                return this.query.systemId;
            });
        }
        this.working = false;
        this.search();
    }
    ;
    onCompanyIdChanged() {
        this.siteId = this.filteredSites[0];
        this.system = this.filteredSystems[0];
        this.loadAuthors()
            .then(() => {
            this.authorId = this.users[0];
            this.search();
        });
    }
    onSiteIdChanged() {
        this.system = this.filteredSystems[0];
        this.search();
    }
    // set
    edit(item) {
        this.$router.push({ name: RouteNames.MaintenanceComment, params: { id: item.logId.toString() } });
    }
    ;
    archive(item) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this comment?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            maintenanceClient
                .delete(item.logId)
                .then(() => {
                item.whenDeleted = new Date();
                Notifier.onOk(`Log # ${item.logId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(item) {
        if (this.working)
            return;
        this.working = true;
        maintenanceClient
            .restore(item.logId)
            .then(() => {
            item.whenDeleted = undefined;
            Notifier.onOk(`Log # ${item.logId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = "W";
        this.setDateRange();
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.search();
    }
    ;
    setDateRange() {
        this.snoozeSearch = true;
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        switch (this.dateFilterOption) {
            case "W":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "M":
                range = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
            case "3M":
                range = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                break;
            case "Y":
                range = DateHelper.getDateRange(DatePresetOption.OneYear);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.query.startTime = range.start;
        this.query.endTime = range.end;
        this.snoozeSearch = false;
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    getCachedFiltersFromLocalStorage() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        let cachedQuery = CacheHelper.getItem(RouteNames.MaintenanceComments, "MaintenanceLogQueryModel");
        this.query = (_a = cachedQuery === null || cachedQuery === void 0 ? void 0 : cachedQuery.query) !== null && _a !== void 0 ? _a : this.query;
        this.setDateFilterOption((_b = cachedQuery === null || cachedQuery === void 0 ? void 0 : cachedQuery.dateFilterOption) !== null && _b !== void 0 ? _b : this.dateFilterOption);
        if ((_c = this.query) === null || _c === void 0 ? void 0 : _c.companyId)
            this.companyId = (_d = this.companies.filter(c => { var _a; return c.value == ((_a = this.query) === null || _a === void 0 ? void 0 : _a.companyId); })[0]) !== null && _d !== void 0 ? _d : this.companyId;
        if ((_e = this.query) === null || _e === void 0 ? void 0 : _e.siteId)
            this.siteId = (_f = this.filteredSites.filter(s => { var _a; return s.value == ((_a = this.query) === null || _a === void 0 ? void 0 : _a.siteId); })[0]) !== null && _f !== void 0 ? _f : this.siteId;
        if ((_g = this.query) === null || _g === void 0 ? void 0 : _g.logTypeId)
            this.logTypeId = (_h = this.logTypes.filter(lt => { var _a; return lt.value = (_a = this.query) === null || _a === void 0 ? void 0 : _a.logTypeId; })[0]) !== null && _h !== void 0 ? _h : this.logTypeId;
        if ((_j = this.query) === null || _j === void 0 ? void 0 : _j.systemId)
            this.system = (_k = this.filteredSystems.filter(s => { var _a; return s.value == ((_a = this.query) === null || _a === void 0 ? void 0 : _a.systemId); })[0]) !== null && _k !== void 0 ? _k : this.system;
        if ((_l = this.query) === null || _l === void 0 ? void 0 : _l.componentId)
            this.component = (_m = this.systemComponents.filter(s => { var _a; return s.value == ((_a = this.query) === null || _a === void 0 ? void 0 : _a.componentId); })[0]) !== null && _m !== void 0 ? _m : this.component;
        if ((_o = this.query) === null || _o === void 0 ? void 0 : _o.authorId)
            this.authorId = (_p = this.users.filter(u => { var _a; return u.value == ((_a = this.query) === null || _a === void 0 ? void 0 : _a.authorId); })[0]) !== null && _p !== void 0 ? _p : this.authorId;
    }
    ;
    getFormattedDate(date) {
        return moment(date).format("DD MMM YYYY, HH:mm");
    }
    get filteredSites() {
        let sites = (this.sites || [])
            .filter(site => { var _a; return ((_a = this.companyId) === null || _a === void 0 ? void 0 : _a.value) == null || site.companyId == this.companyId.value; })
            .map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        return [{ value: null, text: `All sites` }].concat(sites);
    }
    get filteredSystems() {
        let systems = this.systems
            .filter(system => { var _a, _b; return (((_a = this.companyId) === null || _a === void 0 ? void 0 : _a.value) == null || this.companyId.value == system.companyId) && (((_b = this.siteId) === null || _b === void 0 ? void 0 : _b.value) == null || this.siteId.value == system.siteId); })
            .map((system) => {
            return {
                value: system.systemId,
                text: system.systemName
            };
        });
        return [{ value: null, text: `All systems` }].concat(systems);
    }
    get systemId() {
        return this.query.systemId;
    }
    ;
    get system() {
        return this.filteredSystems.filter(item => {
            return item.value == this.systemId;
        })[0] || null;
    }
    ;
    set system(item) {
        if (item) {
            this.query.systemId = item.value;
        }
    }
    ;
    get componentId() {
        return this.query.componentId;
    }
    ;
    get component() {
        return this.systemComponents.filter(item => {
            return item.value == this.componentId;
        })[0] || null;
    }
    ;
    set component(item) {
        if (!item)
            return;
        this.query.componentId = item.value;
    }
    ;
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set companyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get siteId() {
        return this.filteredSites.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get authorId() {
        return this.users.filter(item => {
            return item.value == this.query.authorId;
        })[0] || null;
    }
    ;
    set authorId(item) {
        if (!item)
            return;
        this.query.authorId = item.value;
    }
    ;
    get logTypeId() {
        return this.logTypes.filter(item => {
            return item.value == this.query.logTypeId;
        })[0];
    }
    ;
    set logTypeId(item) {
        if (!item)
            return;
        this.query.logTypeId = item.value;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    get readyToBindQueryStringFilters() {
        return this.systemsLoaded && this.lookupsLoaded;
    }
    ;
    get areDatesInvalid() {
        if (this.query.startTime == null || this.query.endTime == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.startTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.endTime)
            return false;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("comments-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
};
__decorate([
    Watch("query.systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "getSystemComponents", null);
__decorate([
    Watch("query.startTime"),
    Watch("query.endTime"),
    Watch("query.authorId"),
    Watch("query.componentId"),
    Watch("query.logTypeId"),
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "onSortChanged", null);
__decorate([
    Watch("readyToBindQueryStringFilters"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "setDefaultFilters", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceHistoryVue.prototype, "onSiteIdChanged", null);
MaintenanceHistoryVue = __decorate([
    Component({
        name: "MaintenanceHistoryVue"
    })
], MaintenanceHistoryVue);
export default MaintenanceHistoryVue;
